/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Translation_Options_HeadingInputs */

const en_edit_event_group_translation_options_heading = /** @type {(inputs: Edit_Event_Group_Translation_Options_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translation Options`)
};

const fr_edit_event_group_translation_options_heading = /** @type {(inputs: Edit_Event_Group_Translation_Options_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options de traduction`)
};

const de_edit_event_group_translation_options_heading = /** @type {(inputs: Edit_Event_Group_Translation_Options_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzungsoptionen`)
};

const it_edit_event_group_translation_options_heading = /** @type {(inputs: Edit_Event_Group_Translation_Options_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni di traduzione`)
};

const ru_edit_event_group_translation_options_heading = /** @type {(inputs: Edit_Event_Group_Translation_Options_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Параметры перевода`)
};

const es_edit_event_group_translation_options_heading = /** @type {(inputs: Edit_Event_Group_Translation_Options_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones de traducción`)
};

const zh_cn2_edit_event_group_translation_options_heading = /** @type {(inputs: Edit_Event_Group_Translation_Options_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻译选项`)
};

const ja_edit_event_group_translation_options_heading = /** @type {(inputs: Edit_Event_Group_Translation_Options_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳オプション`)
};

const hi_edit_event_group_translation_options_heading = /** @type {(inputs: Edit_Event_Group_Translation_Options_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद विकल्प`)
};

const pt_pt2_edit_event_group_translation_options_heading = /** @type {(inputs: Edit_Event_Group_Translation_Options_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções de tradução`)
};

/**
* | output |
* | --- |
* | "Translation Options" |
*
* @param {Edit_Event_Group_Translation_Options_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_translation_options_heading = /** @type {((inputs?: Edit_Event_Group_Translation_Options_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Translation_Options_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_translation_options_heading(inputs)
	if (locale === "de") return de_edit_event_group_translation_options_heading(inputs)
	if (locale === "it") return it_edit_event_group_translation_options_heading(inputs)
	if (locale === "ru") return ru_edit_event_group_translation_options_heading(inputs)
	if (locale === "es") return es_edit_event_group_translation_options_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_translation_options_heading(inputs)
	if (locale === "ja") return ja_edit_event_group_translation_options_heading(inputs)
	if (locale === "hi") return hi_edit_event_group_translation_options_heading(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_translation_options_heading(inputs)
	return en_edit_event_group_translation_options_heading(inputs)
});